import { gql } from "@apollo/client";

export const CHECK_USER_IDENTITY = gql`
  query checkUserInformationValidity(
    $userSSN: String!
    $userDOB: String!
    $hasUserResubmitted: Boolean
  ) {
    checkUserValidInformation(
      userSSN: $userSSN
      userDOB: $userDOB
      hasUserResubmitted: $hasUserResubmitted
    ) {
      shouldReenterInformation
      error
    }
  }
`;

export const UPDATE_VERIFY_IDENTITY_STEP = gql`
  mutation updateIdentityStep(
    $userSSN: String!
    $userDOB: String!
    $hasUserResubmitted: Boolean
  ) {
    updateVerifiyIdentityStep(
      userSSN: $userSSN
      userDOB: $userDOB
      hasUserResubmitted: $hasUserResubmitted
    ) {
      status
      message
    }
  }
`;